"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedalliaLoader = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const constants_1 = require("./constants");
class MedalliaLoader extends web_ui_framework_1.ScriptLibraryLoader {
    constructor(medalliaUrl) {
        super('Medallia', constants_1.LOAD_CONFIG);
        this.medalliaUrl = medalliaUrl;
    }
    getUrls() {
        return [this.medalliaUrl];
    }
}
exports.MedalliaLoader = MedalliaLoader;
//# sourceMappingURL=index.js.map